import PETable from "./PETable";

const PE = () => {
  return <PETable />;
};

export default PE;
